import { ResultOf } from '@graphql-typed-document-node/core';
import { useQuery } from 'urql';
import { graphql } from '~/gql';
import { TagEntityTypes } from '.';

export type Tag = ResultOf<typeof ListTagsDocument>['tags']['edges'][0]['node'];
export { formatTagsToFaceted } from './tagsFaceted';

export const ListTagsDocument = graphql(`
  query ListTags($entityTypes: [String!]) {
    tags(entityTypes: $entityTypes) {
      edges {
        node {
          id
          entityType
          name
          category
          description
          colour
        }
      }
    }
  }
`);

export function useTags(
  entityTypes: string | string[] = TagEntityTypes
): [allTags: Tag[], reload: () => void] {
  const types = typeof entityTypes === 'string' ? [entityTypes] : entityTypes;

  const [result, reexecuteQuery] = useQuery({
    query: ListTagsDocument,
    variables: { entityTypes: types },
  });
  const edges = result.data?.tags.edges;

  const allTags = edges?.map(({ node }) => node) ?? [];
  const reload = () => reexecuteQuery({ requestPolicy: 'network-only' });
  return [allTags, reload];
}
